import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
// @mui
import { Stack } from '@mui/system';
// sections
import Header from './Header';
// reducers
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';
//components
import BasicTable from 'components/BasicTable';
import { columnType, FilterType } from 'components/BasicTable/types';
import { TableLink } from 'theme/elements/Text';
//constants
import {
  BeneficiaryTableColumns,
  BeneficiaryDefaultSort,
  BeneficiaryId,
  beneficiaryType,
  BeneficiaryStatus,
  Beneficiary,
} from 'constants/beneficiary.constants';
import { pagesEnum } from 'constants/ui.constants';
import { getCountries, getCurrencies } from 'state/reducers/global.reducers';
import '/node_modules/flag-icons/css/flag-icons.min.css';
import { Flag } from 'theme/elements/Icons';
import { Box, Button, Menu, MenuItem, Tooltip, Typography, useTheme } from '@mui/material';
import { FormButton, GeneralButton } from 'theme/elements/Buttons';
import { getUserPermission } from 'state/reducers/user.reducers';
import { UserPermission } from 'constants/user.constants';
import { getMobile } from 'state/reducers/ui.reducers';
import { getCompanyBalances } from 'state/reducers/balance.reducers';
import { useState } from 'react';
import WarningDialog from 'components/WarningDialog';
import { intializeBeneficiary, setBeneficiary, setLoadingBeneficiaries } from 'state/reducers/beneficiary.reducers';
import { API_GET_BENEFICIARY_PAYMENTS_HISTORY } from 'constants/db.constants';
import API from 'services/api.services';
import { PaymentStatus } from 'constants/pay.constants';
import WaitingMessage from 'components/WaitingMessage';

//SERVICES

type obj = { [key: string]: string | number };
type objArray = obj[];

export default function BeneficiariesDashbaord(props: { beneficiaries: objArray }) {
  const { beneficiaries } = props;
  const t = useAppSelector(selectTranslations);
  const navigate = useNavigate();
  const countries = _.keyBy(useAppSelector(getCountries), 'id');
  const currencies = _.keyBy(useAppSelector(getCurrencies), 'id');
  const userPermission = useAppSelector(getUserPermission);
  const isMobile = useAppSelector(getMobile);
  const theme = useTheme();
  const companyBalancesList: any[] = useAppSelector(getCompanyBalances);
  const imageUrl = useAppSelector(selectImageUrl);
  const prefixFields = `page.beneficiary.profile.`;
  const [cantEditDialog, setCantEditDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useAppDispatch();

  const useBeneficiariesColumns = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    let columns: columnType[] = [];
    _.keys(BeneficiaryTableColumns).forEach((element) => {
      let props: columnType = {
        fieldId: BeneficiaryId,
        name: element,
        title: t('page.beneficiary.dashboard.table.column.' + _.snakeCase(element) + '.text'),
        type: BeneficiaryTableColumns[element],
      };
      switch (element) {
        case 'companyName':
          props.eventsHandle = {
            onClick: (event) => {
              event.stopPropagation();
              const target = event.currentTarget as HTMLElement;
              navigate(`/${pagesEnum.BENEFICIARY}/details/${target.id}`);
            },
          };
          props.customValueHandle = (value, record) => {
            return (
              <Box sx={{ display: 'flex' }}>
                <Stack spacing={2} direction="row">
                  <Flag title={_.lowerCase(String(record.countryCode))} />
                  <Stack>
                    <TableLink title={value} />
                    <Typography variant="caption" color="#5d777b">
                      {record?.currencyId ? _.get(currencies, record.currencyId)?.code || '' : ''}
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            );
          };
          break;
        case 'subStatus':
          props.customValueHandle = (value, record) => {
            return (
              record.statusValue === BeneficiaryStatus.DeclinedForRepair ?
                <Stack direction={'row'} gap={1} sx={{ position: 'relative' }}>
                  <Box>{t('page.beneficiary.dashboard.beneficiary_status.decline_reason.text')}</Box>
                  {_.isArray(record.beneficiaryDeniedMessages) &&
                    <Tooltip title={_.last(record.beneficiaryDeniedMessages)?.message}>
                      <Button sx={{
                        background: theme.palette.root.brandSecondary_014,
                        minWidth: 20,
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        textAlign: 'center',
                        color: theme.palette.primary.main,
                        fontFamily: 'math',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textTransform: 'lowercase',
                        className: 'list-button-basic'
                      }}
                      >i</Button>
                    </Tooltip>
                  }
                </Stack> : ''
            );
          };
          break;
      }
      columns.push(props);
    });
    return columns;
  };

  const foramtValues = (beneficiaries: objArray) => {
    let list: objArray = [];
    beneficiaries.forEach((beneficiary) => {
      let bn: obj = {
        [BeneficiaryId]: _.get(beneficiary, BeneficiaryId),
        currencyId: beneficiary.currencyId,
        currency: beneficiary?.currencyId ? _.get(currencies, beneficiary.currencyId)?.code || '' : '',
        beneficiaryDeniedMessages: _.get(beneficiary, 'beneficiaryDeniedMessages'),
      };
      _.keys(BeneficiaryTableColumns).forEach((key) => {
        switch (key) {
          case 'companyName':
            bn[key] = beneficiary.nickname;
            break;
          case 'countryId':
            let country = _.get(countries, beneficiary.countryId);
            bn[key] = country ? country.name : beneficiary[key];
            bn.countryCode = country ? country.alpha2Code : null;
            break;
          case 'type':
            bn[key] = t(
              'page.beneficiary.dashboard.beneficiary_type.' +
              _.snakeCase(String(beneficiary[key])) +
              '.text'
            );
            break;
          case 'status':
            bn[key] = t(
              'page.beneficiary.dashboard.beneficiary_status.' +
              _.snakeCase(String(beneficiary[key])) +
              '.text'
            );
            bn[`${key}Value`] = beneficiary[key];
            break;
          case 'payments':
            let payments: string[] = [];
            if (beneficiary?.isLocalPaymentAllowed) {
              payments.push(
                t('page.pay.create.step.2.beneficiary_payment_preferences.payment_type.regular.text')
              );
            }
            if (beneficiary?.isPriorityPaymentAllowed) {
              payments.push(
                t('page.pay.create.step.2.beneficiary_payment_preferences.payment_type.priority.text')
              );
            }
            _.assign(bn, { payments: payments.join(', ') });
            break;
          default:
            bn[key] = beneficiary[key];
        }
      });
      list.push(bn);
    });
    return list;
  };


  const handleEditClick = async (row) => {
    setIsLoading(true)
    const beneficiary = beneficiaries.find(beneficiary => beneficiary.id === row.id);
    if (beneficiary) {
      dispatch(intializeBeneficiary(beneficiary as unknown as Beneficiary));
    }

    let res = await API.getInstance().post(API_GET_BENEFICIARY_PAYMENTS_HISTORY, { beneficiaryId: row.id });
    const payments = res.data.payments;
    const hasPaymentsInProgress = payments.some(
      (p) =>
        ![PaymentStatus.Completed, PaymentStatus.Failed, PaymentStatus.Rejected].includes(p.status)
    );
    setIsLoading(false)
    if (hasPaymentsInProgress) {
      setCantEditDialog(true);
    } else {
      navigate(`/${pagesEnum.BENEFICIARY}/edit/${_.get(row, BeneficiaryId)}`);
    }
  }

  return (
    <>
      {isLoading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            inset: 0,
            backgroundColor: 'white',
            zIndex: 1000,
          }}
        >
          <WaitingMessage />
        </Box>
      )}
      <WarningDialog
        open={cantEditDialog}
        title={t(prefixFields + 'header.cannot_edit.text')}
        handleCancel={() => setCantEditDialog(false)}
      />
      <Box sx={{ '& .table-wrap-stack': { display: 'flex', flexDirection: 'column', gap: 4 }, '& .tableActionsWrap': { [theme.breakpoints.down('sm')]: { width: '00%' } } }}>
        <Stack spacing={{ sm: 5, xs: 2 }}>
          <Header userPermission={userPermission} />
          <BasicTable
            actionsCell={
              _.includes([UserPermission.OPERATIONER, UserPermission.SIGNER], userPermission)
                ? [

                  {
                    condition: {
                      column: 'status',
                      value: [BeneficiaryStatus.Approved, BeneficiaryStatus.ApprovedWithRisk],
                    },
                    element: (
                      <FormButton>
                        <GeneralButton height="inherit">
                          <Button
                            className="hiddenActions"
                            size={isMobile ? 'small' : 'medium'}
                            variant={isMobile ? 'outlined' : 'contained'}
                            fullWidth={isMobile ? true : false}
                          >
                            {t('page.beneficiary.dashboard.pay_button.text')}
                          </Button>
                        </GeneralButton>
                      </FormButton>
                    ),
                    onClick: (row) => {
                      navigate(`/${pagesEnum.PAY}/new/${_.get(row, BeneficiaryId)}`);
                    },
                  },
                  {
                    condition: {
                      column: 'status',
                      value: [
                        BeneficiaryStatus.Approved,
                        BeneficiaryStatus.ApprovedWithRisk,
                        BeneficiaryStatus.DeclinedForRepair,
                        BeneficiaryStatus.PendingBankAccountDetails
                      ],
                    },
                    element: (
                      <FormButton>
                        <GeneralButton height="inherit">
                          <img
                            src={imageUrl(`${prefixFields}edit.icon`) || '/icons/edit.svg'}
                            width="40"
                            height="40"
                            style={{ cursor: 'pointer' }}
                          />
                        </GeneralButton>
                      </FormButton>
                    ),
                    onClick: (row) => {
                      handleEditClick(row)
                    },
                  },
                ]
                : []
            }
            fieldId="id"
            rowsClass="hoverButton"
            data={foramtValues(beneficiaries)}
            columns={useBeneficiariesColumns()}
            defaultSortBy={BeneficiaryDefaultSort}
            includeSearchBox={true}
            searchColumns={['companyName', 'countryId', 'reference']}
            filterList={{
              currency: {
                type: FilterType.unique,
                label: t('page.beneficiary.dashboard.filter.currency_id.text'),
                primaryOption: t('page.beneficiary.dashboard.filter.currency_id.select_all.text'),
              },
              countryId: {
                type: FilterType.unique,
                label: t('page.beneficiary.dashboard.filter.country_id.text'),
                primaryOption: t('page.beneficiary.dashboard.filter.country_id.select_all.text'),
              },
              payments: {
                type: FilterType.unique,
                label: t('page.beneficiary.dashboard.filter.payments.text'),
                primaryOption: t('page.beneficiary.dashboard.filter.payments.select_all.text'),
              },
              status: {
                type: FilterType.unique,
                label: t('page.beneficiary.dashboard.filter.status.text'),
                primaryOption: t('page.beneficiary.dashboard.filter.status.select_all.text'),
              },
            }}
          />

        </Stack>
      </Box>
    </>
  );
}
